import { RootState } from 'store/configureStore';

export const unreadNotificationsSelector = (state: RootState) =>
  state.notification.unread;
export const readNotificationsSelector = (state: RootState) =>
  state.notification.read;
export const isLoadingReadNotificationsSelector = (state: RootState) =>
  state.notification.isLoadingReadNotifications;
